'use strict';

/*------------------------------------*\
 * JS Main entry file
 \*------------------------------------*/
import './config';

// Import utilities.
import '@utilities/in-view';

// Import Singletons
import '@utilities/detect-touch';
import 'lazysizes';

var myNodeList = document.querySelectorAll('[js-hook-detail-selection] > li');
var imageList = document.querySelectorAll('[js-hook-details] > .detail');

[].forEach.call(myNodeList, function (item) {
    item.addEventListener("mouseenter", function(t){
        let id = item.dataset.id;
        document.querySelector('.detail-'+id).classList.add('active');
    });
    item.addEventListener("mouseleave", function(t){
        imageList.forEach(function (img) {
            img.classList.remove('active');
        });
    });
});


var selectItems = document.querySelectorAll('[js-hook-selectitems] > .item');

[].forEach.call(selectItems, function (item) {
    item.addEventListener("click", function(t){



        if(!item.classList.contains('item-selected')){
            [...item.parentElement.children].forEach(child =>
                child.classList.remove('item-selected')
            );
            item.classList.add('item-selected');

            let itemval = item.dataset.value;
            let hiddenInput = item.dataset.input;

            document.querySelector("#"+hiddenInput).value = itemval;
            checkItemForm();

            let producttype = document.querySelector('[js-hook-producttype]').dataset.pt;

            if(producttype == "facemask" || producttype == "facemaskprint"){

                if(!isNaN(item.dataset.value)){
                    let p = document.querySelector('[js-hook-baseprice]').dataset.price;
                    let a = parseInt(item.dataset.value);
                    document.querySelector('[js-hook-priceamount]').innerHTML = parseInt(p) + (parseInt(a)-1)*(parseInt(p)-10);
                }

            } else {

                if(!isNaN(item.dataset.value)){
                    let p = document.querySelector('[js-hook-baseprice]').dataset.price;
                    document.querySelector('[js-hook-priceamount]').innerHTML = p*item.dataset.value;
                }

            }

            // let p = item.dataset.price;
            // if(p != undefined){
            //
            // }

        }
    });
});

var selectItems = document.querySelectorAll('[js-hook-features] > li');

[].forEach.call(selectItems, function (item) {
    item.addEventListener("click", function(t){
        if(!item.classList.contains('selected')){
            [...item.parentElement.children].forEach(child =>
                child.classList.remove('selected')
            );
            item.classList.add('selected');
            let itemval = item.dataset.value;
            let hiddenInput = item.dataset.input;

            document.querySelector("#"+hiddenInput).value = itemval;
            checkItemForm();



        }
    });
});

document.querySelector("[js-hook-comments]").addEventListener("input", function(e) {
    document.getElementById('comments').value = document.querySelector("[js-hook-comments]").textContent;
}, false);

function checkItemForm(){

    let producttype = document.querySelector('[js-hook-producttype]').dataset.pt;

    if(producttype == "facemask"){

        if(document.querySelector("#fabric").value != "" && document.querySelector("#cord").value != "" && document.querySelector("#size").value != "" && document.querySelector("#amount").value != ""){
            document.querySelector('[js-hook-contactinfo]').classList.remove('sii-hidden');
            document.querySelector('.form-next').classList.remove('disabled');

            document.querySelector('[js-hook-formnext]').addEventListener("click", function(){
                document.querySelector("[js-hook-contactinfo]").scrollIntoView({ behavior: 'smooth', block: 'start' });
            });

        }

    } else if (producttype == "facemaskprint"){

        if(document.querySelector("#fabric").value != "" && document.querySelector("#cord").value != "" && document.querySelector("#print").value != "" && document.querySelector("#size").value != "" && document.querySelector("#amount").value != ""){
            document.querySelector('[js-hook-contactinfo]').classList.remove('sii-hidden');
            document.querySelector('.form-next').classList.remove('disabled');

            document.querySelector('[js-hook-formnext]').addEventListener("click", function(){
                document.querySelector("[js-hook-contactinfo]").scrollIntoView({ behavior: 'smooth', block: 'start' });
            });

        }

    } else {

        if(document.querySelector("#amount").value != ""){
            document.querySelector('[js-hook-contactinfo]').classList.remove('sii-hidden');
            document.querySelector('.form-next').classList.remove('disabled');

            document.querySelector('[js-hook-formnext]').addEventListener("click", function(){
                document.querySelector("[js-hook-contactinfo]").scrollIntoView({ behavior: 'smooth', block: 'start' });
            });

        }

    }
}




// WEBPACK FOOTER //
// /Users/sandersturing/Sites/EXT/korinna/frontend/source/javascript/main.js